import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spark" }
const _hoisted_2 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "suggestion pointer",
    underline: "",
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('ask-ai', {text: $options.text}))),
    onMouseenter: _cache[1] || (_cache[1] = $event => ($data.hover = true)),
    onMouseleave: _cache[2] || (_cache[2] = $event => ($data.hover = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Icon, {
        class: "spark",
        size: "1.6rem",
        icon: "spark-1",
        stroke: "var(--brand-700)",
        hover: $data.hover
      }, null, 8 /* PROPS */, ["hover"])
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString($options.text), 1 /* TEXT */)
  ], 32 /* NEED_HYDRATION */))
}